import { SELF, VERIFIED } from "../../internal/shared/permissions/symbols";
export default function getUnverifiedToken() {
    return {
        [SELF]: {},
        [VERIFIED]: false
    };
}

//# sourceMappingURL=getUnverifiedToken.js.map